//antd
import Card from 'antd/lib/card'
import Col from 'antd/lib/col'
import Row from 'antd/lib/row'


const HowItWorks = () => {
  const steps = [
    {
      title: '1. Pide en USA',
      desc: 'Comprá en Amazon, eBay o cualquier tienda online en USA.',
    },
    {
      title: '2. Recibimos tu paquete',
      desc: 'Lo recibimos en nuestra bodega en Miami y lo registramos para envío.',
    },
    {
      title: '3. Te lo llevamos a Nicaragua',
      desc: 'Te llevamos tu paquete Aéreo/Maritimo rápido y seguro a Nicaragua.',
    },
  ];

  return (
    <div className="py-5">
      <h2 className="text-center mb-4">¿Cómo funciona?</h2>
      <Row gutter={16}>
        {steps.map((step, index) => (
          <Col key={index} xs={24} md={8}>
            <Card title={step.title} className="mb-4 shadow">
              <p>{step.desc}</p>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default HowItWorks;